<template>
  <div class="withdraw-details container-fluid">
    <withdraw-details-pc class="pc-show"></withdraw-details-pc>
    <withdraw-details-m class="phone-show"></withdraw-details-m>
  </div>
</template>

<script>
  import WithdrawDetailsPc from '../../components/withdrawDetails/withdrawDetailsPc.vue'
  import withdrawDetailsM from '../../components/withdrawDetails/withdrawDetailsM.vue'

  export default {
    name: 'withdraw-detail-view',
    components: {WithdrawDetailsPc, withdrawDetailsM}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
    letter-spacing: 0;
  }

  .withdraw-details {
    border: 1px solid #E0D7E3;
    border-radius: .08rem;
  }

  @media screen and (min-width: 768px) {
    .phone-show {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {
    .pc-show {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?8e69ac00